module.exports = __webpack_public_path__ + "img/vertical_3_6_9005.65d616f3.png";